/* ═══════════════════════════════════════════════════════════════
   LANDING ESTAMPIDA FC — JAVASCRIPT
   Reveal on scroll + Stat bars + Hero entrance
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // Helper: comprueba si el elemento está dentro del viewport
  function initRevealOnScroll() {
    const reveals = document.querySelectorAll('.ef-reveal');
    if (!reveals.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: muestra todo si el navegador no soporta IO
      reveals.forEach(el => el.classList.add('ef-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ef-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    reveals.forEach(el => observer.observe(el));
  }

  // Stat bars: se llenan al entrar al viewport
  function initStatBars() {
    const bars = document.querySelectorAll('.ef-stat-bar');
    if (!bars.length) return;

    if (!('IntersectionObserver' in window)) {
      bars.forEach(bar => bar.classList.add('ef-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ef-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    bars.forEach(bar => observer.observe(bar));
  }

  // Hero entrance animation (al cargar)
  function initHeroEntrance() {
    const hero = document.querySelector('.ef-hero');
    if (!hero) return;

    const heroReveals = hero.querySelectorAll('.ef-reveal');
    // Hacé visible inmediatamente con stagger natural por delays CSS
    requestAnimationFrame(() => {
      heroReveals.forEach(el => el.classList.add('ef-visible'));
    });
  }

  // Smooth scroll para anchors internos
  function initSmoothScroll() {
    document.querySelectorAll('.estampida-landing a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#' || targetId === '') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // Init
  function init() {
    initRevealOnScroll();
    initStatBars();
    initHeroEntrance();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
